import { handleActions } from 'redux-actions'
import * as type from './type'
import { COUNT_AGGREGATED_RELATIVE } from './const'
import { COMPANY_CODE_SUNSHINE_SMILE_GERMANY } from '../../../internationalization/const'


export const initialState = {
    processState: {
        startProcessName: null,
        startStatus: null,
        endProcessName: null,
        endStatus: null,
        mode: COUNT_AGGREGATED_RELATIVE,
        companyCode: COMPANY_CODE_SUNSHINE_SMILE_GERMANY,
    },
    yearWeekList: [],
    transitionList: null,
    fetching: false,
    error: null,
}


export default handleActions({

    [type.CHANGE_PROCESS_STATE]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            processState: {
                ...state.processState,
                [name]: value,
            },
        }
    },
    [type.CHANGE_YEAR_WEEK]: (state, action) => {
        const { index, name, value } = action.payload

        const yearWeekList = state.yearWeekList.map((item, mapIndex) => {
            return (mapIndex !== index) ? item : {
                ...item,
                [name]: value,
            }
        })

        if (index >= yearWeekList.length) {
            yearWeekList.push({
                year: (new Date()).getFullYear(),
                [name]: value,
            })
        }

        return {
            ...state,
            yearWeekList,
        }
    },
    [type.DELETE_YEAR_WEEK]: (state, action) => {
        const { index } = action.payload
        return {
            ...state,
            yearWeekList: state.yearWeekList.filter((item, filterIndex) => {
                return index !== filterIndex
            }),
        }
    },

    [type.FIND_TRANSITION_REQUEST]: (state, action) => {
        return {
            ...state,
            cohortList: [],
            fetching: true,
        }
    },
    [type.FIND_TRANSITION_SUCCESS]: (state, action) => {
        const { transitionList } = action.payload
        return {
            ...state,
            transitionList,
            fetching: false,
        }
    },
    [type.FIND_TRANSITION_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },


}, initialState)



// WEBPACK FOOTER //
// ./src/modules/analytics/state/transition/reducer.js